interface ThresholdButtonProps {
	isDisabled?: boolean;
	children: React.ReactNode;
	onClick?: () => void;
}

export const ThresholdButton = ({ 
	isDisabled = false,
	children,
	onClick
}: ThresholdButtonProps) => {
	return (
		<button 
			className="shop-coin-threshold__btn"
			disabled={isDisabled}
			onClick={onClick}
		>
			{children}
		</button>
	);
};